import { CSSProperties } from 'react'

export const activeStyles: CSSProperties = {
  position: 'fixed',
  width: '100%',
  zIndex: '99',
  background: '#f7f7f5',
}
